import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Printer, UserCheck } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { Button } from "../components/ui/button";
import { Card } from "../components/ui/card";
import SearchableSelect from "../components/SearchableSelect";
import { bulanOpts, tahunOpts } from "./PresensiListPage";

const Pct = ({ c, testId }) => (
  <td className="p-3 text-center whitespace-nowrap" data-testid={testId}>
    {c.total === 0 ? <span className="text-slate-300">-</span> : (
      <span className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold ${c.persen >= 75 ? "bg-emerald-50 text-emerald-700" : c.persen >= 50 ? "bg-amber-50 text-amber-700" : "bg-rose-50 text-rose-700"}`}>
        {c.persen}% <span className="font-normal text-slate-500">({c.hadir}/{c.total})</span>
      </span>
    )}
  </td>
);

export default function RekapPelayanPage() {
  const navigate = useNavigate();
  const now = new Date();
  const [bulan, setBulan] = useState(String(now.getMonth() + 1));
  const [tahun, setTahun] = useState(String(now.getFullYear()));
  const [d, setD] = useState(null);

  useEffect(() => {
    api.get("/jadwal/rekap-pelayan", { params: { bulan, tahun } }).then((r) => setD(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [bulan, tahun]);

  return (
    <div className="space-y-4" data-testid="rekap-pelayan-page">
      <div className="flex flex-wrap items-start justify-between gap-3 print:hidden">
        <div>
          <Button variant="ghost" className="rounded-xl mb-1 -ml-2" onClick={() => navigate("/presensi")} data-testid="rekap-pelayan-back"><ArrowLeft className="h-4 w-4 mr-1" />Presensi</Button>
          <h1 className="text-2xl sm:text-3xl font-bold text-slate-900 flex items-center gap-2"><UserCheck className="h-7 w-7 text-[hsl(224,64%,33%)]" />Rekap Kehadiran Pelayan</h1>
          <p className="text-sm text-slate-500 mt-1">Persentase kehadiran tiap pelayan pada Ibadah Pelayan dan Doa Persiapan Pelayan IBR per bulan.</p>
        </div>
        <Button variant="outline" className="rounded-xl min-h-[44px]" onClick={() => window.print()} data-testid="rekap-pelayan-print"><Printer className="h-4 w-4 mr-2" />Cetak</Button>
      </div>
      <Card className="p-3 rounded-2xl grid grid-cols-2 sm:grid-cols-4 gap-2 print:hidden">
        <SearchableSelect options={bulanOpts} value={bulanOpts[Number(bulan) - 1]?.label || ""} onChange={setBulan} placeholder="Bulan" testId="rekap-pelayan-bulan" allowClear={false} />
        <SearchableSelect options={tahunOpts()} value={tahun} onChange={setTahun} placeholder="Tahun" testId="rekap-pelayan-tahun" allowClear={false} />
        {d && <div className="col-span-2 text-xs text-slate-500 self-center sm:text-right" data-testid="rekap-pelayan-info">
          {d.jumlah_sesi["Ibadah Pelayan"]} sesi Ibadah Pelayan · {d.jumlah_sesi["Doa Persiapan Pelayan IBR"]} sesi Doa Persiapan · {d.pelayan.length} pelayan</div>}
      </Card>
      {d && (d.pelayan.length === 0
        ? <Card className="p-8 rounded-2xl text-center text-slate-500" data-testid="rekap-pelayan-empty">Belum ada sesi Ibadah Pelayan / Doa Persiapan pada bulan ini.</Card>
        : <Card className="rounded-2xl overflow-x-auto">
          <table className="w-full text-sm min-w-[640px]" data-testid="rekap-pelayan-table">
            <thead className="bg-slate-50 text-slate-600">
              <tr><th className="p-3 text-left">Pelayan</th><th className="p-3 text-left hidden md:table-cell">Bidang</th><th className="p-3 text-center">Ibadah Pelayan</th><th className="p-3 text-center">Doa Persiapan</th><th className="p-3 text-center">Total</th></tr>
            </thead>
            <tbody>
              {d.pelayan.map((p) => (
                <tr key={p.jemaat_id} className="border-t" data-testid={`rekap-pelayan-row-${p.jemaat_id}`}>
                  <td className="p-3 font-medium text-slate-800">{p.nama}</td>
                  <td className="p-3 text-slate-500 text-xs hidden md:table-cell">{p.bidang.join(", ") || "-"}</td>
                  <Pct c={p.ibadah_pelayan} testId={`rekap-ip-${p.jemaat_id}`} />
                  <Pct c={p.doa_persiapan} testId={`rekap-dp-${p.jemaat_id}`} />
                  <Pct c={p.total} testId={`rekap-total-${p.jemaat_id}`} />
                </tr>
              ))}
            </tbody>
          </table>
        </Card>)}
    </div>
  );
}
